/** @format */

const template = `
<div class="row" ng-repeat="selectedObject in ctrl.selectedObjects track by $index">
  <div class="input-col col-11">
    <referred-object-select-editor
      id="selectedObject[ctrl.idAttribute]"
      name="{{ctrl.name}}-$index"
      disabled-ids="ctrl.disabledIds"
      placeholder="{{ctrl.placeholder}}"
      show-short-name="{{ctrl.showShortName}}"
      model="ctrl.model"
      university-org-id="ctrl.universityOrgId"
      show-all-universities="{{ctrl.showAllUniversities}}"
      on-select="ctrl.onSelect($index, selectedObject, obj)"
      reversed-order="ctrl.reversedOrder"></referred-object-select-editor>
  </div>
  <div class="button-col col-1">
    <button
      type="button"
      class="btn btn-primary btn-naked btn-lg form-control"
      title="{{::'SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.REMOVE' |translate}}"
      ng-click="ctrl.remove($index)"
      ><sis-icon icon="delete"></sis-icon
    ></button>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <ul class="error-list">
      <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.has_duplicate_values']" translate
        >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.HAS_DUPLICATE_VALUES</li
      >
      <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.id_missing']" translate
        >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.REFERRED_OBJECT_MISSING</li
      >
      <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.required']" translate
        >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.REQUIRED</li
      >
      <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.too_many']" translate-values="{ maxCount: ctrl.maxCount }" translate
        >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.TOO_MANY</li
      >
      <li class="ng-hide" ng-show="ctrl.form.$error[ctrl.name + '.too_few']" translate-values="{ minCount: ctrl.minCount}" translate
        >SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.TOO_FEW</li
      >
    </ul>
  </div>
</div>

<button type="button" class="link-button" ng-disabled="ctrl.disableAdd" ng-click="ctrl.addNew()" data-cy="add-button">
  <sis-icon icon="ring-plus"></sis-icon>{{'SIS_COMPONENTS.OBJECT.REFERRED_OBJECT_MULTI_SELECT_EDITOR.ADD' | translate}}
</button>
`;
export default template;
